import React, { useMemo, useState } from 'react';
import { motion } from "framer-motion";
import Wrapper from 'global/wrappers/Wrapper';
import { _swiperMenuTypes, SwiperMenu } from './SwiperMenu';
import { gEnums } from 'global/enums/globalEnums';

export const MiniSwiper = ({
  swipeItems,
  className = '',
}) => {

  const [activeIndex, setActiveIndex] = useState(0)
  const handleIndexChange = (index) => setActiveIndex(index)

  const slides = useMemo(() => {
    return _.map(swipeItems, (swipeItem, index) => {
      return <div key={index}>
        {swipeItem ? swipeItem.content : <div>---</div>}
      </div>
    })
  }, [swipeItems, activeIndex])

  const slide = slides[activeIndex];

  return <Wrapper
    header={<SwiperMenu
      swipeContentType={gEnums.swipeContentTypes.normalItems}
      menuItems={swipeItems}
      swiperMenuType={_swiperMenuTypes.buttons}
      activeIndex={activeIndex}
      handleIndexChange={handleIndexChange}
    />}
    content={<div className={`mini-swiper ${className}`}>
      {slide}
    </div>}
  ></Wrapper>

  // return (
  //   <div className={`mini-swiper ${className}`}>
  //     {slide}
  //   </div>
  // );
};
